import vhCheck from 'vh-check';

vhCheck();
